// extracted by mini-css-extract-plugin
module.exports = {"container":"SoundBar_container__TAjvB","icon":"SoundBar_icon__21MyF","player_sound_bar":"SoundBar_player_sound_bar__P2qWG"};